import {
  DepartureArrivalDateTimeDTO,
  EventCodeDTO,
  EventDTO,
  FromToDTO,
  LocationDTO,
  TransportModeDTO,
  TransportTypeDTO,
} from "../api/response.types";
import { CardDates, DateTimeModel, SearchCoordinateDTO } from "entities/shared/shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";

export type DateModel = Record<keyof typeof CardDates, Nullable<DateTimeModel>>;

export const ParcelTransportTypeModel = {
  ...TransportTypeDTO,
} as const;

export type ParcelFromToModel = FromToDTO;

export type ParcelDepartureArrivalDateTimeModel = DepartureArrivalDateTimeDTO;

export const EventCodeModel = {
  ...EventCodeDTO,
} as const;

export type EventLocationModel = LocationDTO;

export const TransportModeModel = {
  ...TransportModeDTO,
} as const;

export type ParcelLocationModel = LocationDTO;

export type ParcelSearchCoordinatesModel = SearchCoordinateDTO;

export type ParcelEventModel = EventDTO & {
  transportType: ValueOf<typeof TransportModeModel>;
  orderID: number | null;
  eventCode: ValueOf<typeof EventCodeModel> | null;
};

export type ParcelTransformedEventModel = { location: string | null; events: ParcelEventModel[] };

export type ParcelRouteModel = {
  from: ParcelFromToModel | null;
  to: ParcelFromToModel | null;
  path: ParcelSearchCoordinatesModel[];
  isActual: boolean;
} & DateModel;
